'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = invited;

var _immutable = require('immutable');

var _InvitedActionTypes = require('../actionTypes/InvitedActionTypes');

var initialState = new _immutable.Map({
  tokenIsValid: false
});

function invited() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type;

  switch (type) {
    case _InvitedActionTypes.TOKEN_VALIDATED:
      return state.set('tokenIsValid', true);

    default:
      return state;
  }
}
module.exports = exports['default'];